import React, { useEffect, useState } from 'react'
import Logo from '../../images/company.svg'
import { AiOutlineSlack, AiOutlineTeam } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { IoDocumentTextOutline } from "react-icons/io5";
import { PiFeatherDuotone } from "react-icons/pi";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BiError, BiGlobe, BiMenu, BiNews, BiSlider } from 'react-icons/bi';
import { MdOutlineContactMail, MdContentPaste } from 'react-icons/md';
import { IsChild } from '../../utilities/MenuItems';
import { IoBusinessOutline } from "react-icons/io5";
import { CiGrid31 } from "react-icons/ci";
import { VscSettingsGear } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { fetchSettingGet } from '../../redux/slices/settingGetSlice';
import { URL } from '../../api';

const LeftMenu = ({ closeModal }) => {
    const [path, setPath] = useState(window.location.pathname)
    const auth = useSelector((state) => state.auth.auth)
    const setting = useSelector((state) => state.settingGet.data)
    const dispatch = useDispatch()
    const { t } = useTranslation();

    const LeftMenuItem = ({ icon, text, link }) => {
        return (
            <Link
                to={link}
                onClick={closeModal}
                className={link === path || IsChild(path) === link ? 'left-menu-active' : 'left-menu-item'}
            >
                <div>{icon}</div>
                <div className='ml-2'><span className='f14'>{text}</span></div>
            </Link>
        )
    }

    const getData = async () => await dispatch(fetchSettingGet())
    useEffect(() => { getData() }, [dispatch])

    const LeftLogoCard = () => {
        return (
            <div className='left-logo-card'>
                <div className='d-flex justify-content-start pl-2'>
                    <div><img src={setting?.files?.length ? `${URL}${setting?.files[setting?.files?.length - 1]}` : Logo} alt='' /></div>
                </div>
            </div>
        )
    }

    return (
        <div className='left-menu'>
            <LeftLogoCard />

            <div>
                <div className='mt-2'>
                    <div className='mt-4 pl-3'><small className='color4'>{t("menu")}</small></div>
                    <LeftMenuItem link="/" icon={<AiOutlineSlack size={20} />} text={t("dashboard")} />
                    {/* <LeftMenuItem link="/pages" icon={<MdPages size={20} />} text={t("page_management")} /> */}
                    {/* <LeftMenuItem link="/bulletins" icon={<BiUserCheck size={20} />} text={t("bulletin_register")} /> */}
                    {/* <LeftMenuItem link="/form" icon={<BiMessage size={20} />} text={t("form_management")} /> */}
                    <LeftMenuItem link="/slider-groups" icon={<BiSlider size={20} />} text={t("slider_management")} />
                    <LeftMenuItem link="/menu-groups" icon={<BiMenu size={20} />} text={t("menu_management")} />
                    <LeftMenuItem link="/product" icon={<CiGrid31 size={20} />} text={t("product_management")} />
                    <LeftMenuItem link="/about" icon={<IoBusinessOutline size={20} />} text={t("about_management")} />
                    <LeftMenuItem link="/document" icon={<IoDocumentTextOutline size={20} />} text={t("document_management")} />
                    <LeftMenuItem link="/news" icon={<BiNews size={20} />} text={t("news_management")} />
                    {/* <LeftMenuItem link="/language" icon={<HiLanguage size={20} />} text={t("language_management")} /> */}
                    <LeftMenuItem link="/content" icon={<MdContentPaste size={20} />} text={t("general_content")} />

                    <div className='mt-4 pl-3'><small className='color4'>{t("settings")}</small></div>
                    <LeftMenuItem link="/users" icon={<AiOutlineTeam size={20} />} text={t("users")} />
                    {/* <LeftMenuItem link="/roles" icon={<RiKeyLine size={20} />} text={t("role")} /> */}
                    <LeftMenuItem link="/seo" icon={<BiGlobe size={20} />} text={t("seo_setting")} />
                    <LeftMenuItem link="/contact" icon={<MdOutlineContactMail size={20} />} text={t("contact_management")} />
                    <LeftMenuItem link="/settings" icon={<VscSettingsGear size={20} />} text={t("site_settings")} />
                    {/* <LeftMenuItem link="/account" icon={<RiUserLine size={20} />} text={t("account_settings")} /> */}
                    <LeftMenuItem link="/log" icon={<BiError size={20} />} text={t("log_saved")} />
                    {/* <LeftMenuItem link="#" icon={<BsQuestionCircle size={20} />} text={t("support_services")} /> */}
                    <LeftMenuItem link="#" icon={<PiFeatherDuotone size={20} />} text="LibeCMS" />
                </div>
            </div>
        </div>
    )
}

export default LeftMenu
